<template>
  <div class="tg-layout">
    <div class="nav-header">
      <div class="logo">
        <img src="~/assets/images/logo.png" alt="" :width="124" />
      </div>
      <el-menu class="nav-list" mode="horizontal" @select="clickHref">
        <el-menu-item v-for="top in topMenus" :key="top.data.url" :index="top.data.url">{{ top.name }}</el-menu-item>
      </el-menu>
      <div class="profile">
        <profile :account="admin" :account-name="title" />
      </div>
    </div>
    <!-- 路由组件 -->
    <router-view />
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { isArray, camelcase } from '@/common/js/utils'
import Profile from '@/components/header/profile'

export default {
  name: 'Creat',
  components: {
    Profile
  },
  computed: {
    admin() {
      return Cookies.get('ch_user_name')
    },
    title() {
      return Cookies.get('ch_user_name')
    },
    topMenus() {
      return this.$store.state.menuAuth
    }
  },
  data() {
    const { path } = this.$route
    const media = isArray(path.split('/')) && path.split('/')[2]
    return {
      media: camelcase(media)
    }
  },
  methods: {
    clickHref(index) {
      this.$router.push({ path: index })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.nav-header {
  height: 64px;
  line-height: 64px;
  background: #fff;
  display: flex;

  //  logo
  .logo {
    display: flex;
    justify-content: space-around;
    align-items: center;
    min-width: 172px;
  }

  // 导航栏
  .nav-list {
    border-bottom: none;
    flex: 1;
    .el-menu-item {
      color: #333;
      height: 64px;
      line-height: 64px;
      &:hover {
        color: $primary-color;
      }
    }
  }
}
</style>
